/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato della domanda esercente
 */
export enum RichiestaPraticaEsercenteStatus {

    SOTTOMESSA = 'SOTTOMESSA',

    RITIRATA = 'RITIRATA',

    RIFIUTATA = 'RIFIUTATA',

    ACCETTATA_IN_ATTESA_CONVENZIONE = 'ACCETTATA_IN_ATTESA_CONVENZIONE',

    ACCETTATA_IN_ATTESA_VALIDAZIONE_CONVENZIONE = 'ACCETTATA_IN_ATTESA_VALIDAZIONE_CONVENZIONE',

    ACCETTATA_CONVENZIONE_RIFIUTATA = 'ACCETTATA_CONVENZIONE_RIFIUTATA',

    ABILITATA = 'ABILITATA',

    DISABILITATA = 'DISABILITATA'
}

